import $ from "./util/dom.js";
import touch from "./util/touch.js";
import nav from "./components/nav.js";
import page from "./views/page.js";
import login from "./views/login.js";
import user from "./user.js";
import Settings from "./settings.js";
import Api from "./api.js";
import NotificationService from "./services/notificationService.js";
import Translations from "./translations.js";
import Data from "./data.js";

let container;
async function setupUI() {
    touch.init();
    
    let currentLang = Settings.getLanguage();
    await Translations.load(currentLang);
    Data.init();

    container = $("main");
    document.body.appendChild(container);

    let isLoggedIn = await user.isLoggedIn();
    
    if (isLoggedIn){
        let newLang = Settings.getLanguage();
        if (currentLang !== newLang){
            await Translations.load(newLang);
            Data.init();
        }
        let theme = Settings.getTheme();
        if (theme==="light") document.body.classList.add("light");
        home();
    }else{
        let theme = Settings.getTheme();
        if (theme==="light") document.body.classList.add("light");
        
        login.render(container).then(()=>{
            user.isLoggedIn().then(async isLoggedIn=>{
                if (isLoggedIn){
                    let newLang = Settings.getLanguage();
                    if (currentLang !== newLang){
                        await Translations.load(newLang);
                        Data.init();
                    }
                    home();
                }else{
                    window.location.reload();
                }
            })
        });
    }

    if (Api.isDev()){
        document.body.appendChild($(".devmode","DEVELOPMENT ENVIRONMENT"));
    }

}

function home(){
    nav.render(container);
    nav.updateStats(true);
    user.renderUserMenu(container);
    let hash = window.location.hash;
    if (hash){
        hash = hash.substr(1);
        page.load(hash,container);
    }else{
        page.load("home",container);
    }

}


document.addEventListener("DOMContentLoaded", function(event) {
    setupUI();
});